import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {addToWizard, setWizard} from '../../../../store/actions';
import AddContacts from './add-contacts';
import AddUser from './add-user';
import ActivateRegistration from './activate-registration';

import './styles.scss';
import {useHistory} from 'react-router-dom';
import {strings} from '../../../../util/strings';

export interface DataValidationProps {
  onSubmit(values: any): any;
  setValid(value: boolean): void;
  nextStep(): void;
  valid: boolean;
  wizard: any;
  addToWizard(value: any): any;
  labels: typeof strings.pt.register;
  messageLabels: typeof strings.pt.messages;
}

function DataValidation(props: DataValidationProps) {
  const {wizard} = props;
  const history = useHistory();

  if (!!!wizard.insuranceValidation) {
    history.push('/');
  }

  const selectedContact =
    wizard.dataValidation && wizard.dataValidation.selectedContact;
  const currentUser =
    wizard.dataValidation && wizard.dataValidation?.currentUser;
  const userContacts = currentUser;

  if (!!!selectedContact && currentUser) {
    // If user hasn't selected a contact to verify
    if (Object.keys(currentUser).length > 0 && userContacts) {
      // Check if is in registered Rios and wso2
      if (!userContacts.phone && !userContacts.email) {
        // Check if both phone and email are empty
        return <AddContacts {...props} />; // If both fields are empty: go to add contact page
      } else {
        return <ActivateRegistration {...props} />; // If both fields are filled: go to the verify contact page
      }
    } else {
      // If user isn't register in either rios or wso2
      return <AddUser {...props} />; // Go to add user page
    }
  } else if (!!selectedContact) {
    // If user has already selected a contact to verify
    return <ActivateRegistration {...props} />; // Go to the verify contact page
  } else {
    return <AddUser {...props} />; // Go to add user page
  }
}

const mapStateToProps = ({wizard, stringsDefault}: any) => ({
  wizard: wizard.value,
  labels: stringsDefault.value.pt.register,
  messageLabels: stringsDefault.value.pt.messages,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(DataValidation)
);
